// extracted by mini-css-extract-plugin
export default {"tag":"PostTag_tag__K7-wu"};